import { CanActivate, Router, UrlTree } from '@angular/router';
import { loadAccountByUuid } from '@common/store';
import { Store } from '@ngrx/store';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { selectLoadedCurrentUser } from 'pl-core-services';
import { InternalAdminService } from '../services';

@Injectable({ providedIn: 'root' })
export class PlUserHasAccountGuard implements CanActivate {
  constructor(
    private router: Router,
    private store: Store,
    private internalAdminService: InternalAdminService
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    const user = await firstValueFrom(this.store.pipe(selectLoadedCurrentUser));
    if (user.is_superuser) return true;
    const isInternalAdmin = this.internalAdminService.isInternalAdmin(user);
    const accountUuid =
      (isInternalAdmin && this.internalAdminService.getAccountUuid()) ||
      undefined;
    const account = await loadAccountByUuid(this.store, accountUuid);
    if (!account) {
      await this.router.navigateByUrl('/no-account', {
        skipLocationChange: true,
      });
      return false;
    }
    return true;
  }
}
